import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';

import { ApiV2Organization } from '../get-type';

const getPath = () => `/v2/organizations/intilaq`;

export async function apiGetV2IntilaqOrganizations() {
  const response = await request.GET<{ organizations: ApiV2Organization[] }>(getPath());
  return response.organizations;
}

export function useSWRV2IntilaqOrganizations() {
  const swr = useSWR(
    () => getPath(),
    () => apiGetV2IntilaqOrganizations(),
    SWR_GLOBAL_CONFIG,
  );
  return { ...swr, organizations: swr.data };
}
